import styled, { css } from "styled-components";

import { setWidth } from "../../utils/css.utils";

const margin = props => {
	if (props.$margin) {
		return `${props.$margin}`;
	} else {
		return `0`;
	}
};

const isEmpty = props => {
	if (props.$isEmpty) {
		const width = props.width - props.$circleBorder * 2;
		return css`
			height: ${width}px;
			width: ${width}px;
			background-color: transparent;
			border: ${props.$circleBorder}px solid gray;
		`;
	}
};

export const Circle = styled.div`
	border-radius: 50%;
	background-color: gray;
	height: 100%;
	${setWidth}
	${isEmpty}
`;

export const HorizontalContainer = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin: ${margin}px;
	height: calc(100% - (${margin}px * 2));
	${setWidth}
`;
